import React from 'react'
import {Route} from 'react-router-dom'
const Layout = React.lazy(() => import('./Layout'))
const Main = React.lazy(() => import('./Main'))

export default (
  <Route path="/referrals" element={<React.Suspense><Layout /></React.Suspense>}>
    <Route index element={<React.Suspense><Main /></React.Suspense>} />
  </Route>
)
